import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "ta-c" };
const _hoisted_2 = ["title"];
const _hoisted_3 = { class: "ta-c" };
const _hoisted_4 = { class: "ta-c" };
const _hoisted_5 = { class: "ta-c" };
const _hoisted_6 = { class: "ta-c" };
const _hoisted_7 = { class: "ta-c" };
const _hoisted_8 = { class: "ta-c" };
const _hoisted_9 = { class: "ta-c" };
import { storeToRefs } from 'pinia';
import { pStore } from '@/pinia';
import OrderStatusChip from '@/components/Common/OrderStatusChip.vue';
import { workerAllocateTargetOrderHeader } from '@/constants/workerAllocate';
import { formatDate } from '@/utils';
import dateFormatType from '@/constants/dateFormatType';
export default /*@__PURE__*/ _defineComponent({
    __name: 'TargetOrder',
    setup(__props) {
        // 라이더 리스트
        const pWorkerAllocate = pStore.piniaWorkerAllocate;
        const { selectedOrder, } = storeToRefs(pWorkerAllocate);
        return (_ctx, _cache) => {
            const _component_v_data_table = _resolveComponent("v-data-table");
            const _directive_tr_highlight = _resolveDirective("tr-highlight");
            return (_openBlock(), _createBlock(_component_v_data_table, {
                hover: "",
                class: "worker-order-list brg-table th-nowrap",
                "hide-default-footer": "",
                "fixed-header": "",
                "item-value": "orderId",
                items: [_unref(selectedOrder)],
                headers: _unref(workerAllocateTargetOrderHeader),
                density: "compact"
            }, {
                item: _withCtx(({ item }) => [
                    _withDirectives((_openBlock(), _createElementBlock("tr", null, [
                        _createCommentVNode(" 주문 아이디 "),
                        _createCommentVNode(" <td class=\"ta-c\">\n          {{ item.orderId }}\n        </td> "),
                        _createCommentVNode(" 당일번호 "),
                        _createElementVNode("td", _hoisted_1, _toDisplayString(item?.todayNumber), 1 /* TEXT */),
                        _createCommentVNode(" 상점명 "),
                        _createElementVNode("td", {
                            class: "ta-c",
                            title: item?.storeName
                        }, _toDisplayString(item?.storeName), 9 /* TEXT, PROPS */, _hoisted_2),
                        _createCommentVNode(" 오더 상태 "),
                        _createElementVNode("td", _hoisted_3, [
                            _createCommentVNode(" 주문 상태 칩 "),
                            _createVNode(OrderStatusChip, {
                                "status-code": item?.statusCode
                            }, null, 8 /* PROPS */, ["status-code"])
                        ]),
                        _createCommentVNode(" 경과시간(분) "),
                        _createElementVNode("td", _hoisted_4, _toDisplayString(item?.orderedAtElapsedTime), 1 /* TEXT */),
                        _createCommentVNode(" 남은시간(분) "),
                        _createElementVNode("td", _hoisted_5, _toDisplayString(item?.displayTime().text), 1 /* TEXT */),
                        _createCommentVNode(" 픽업예상시간 "),
                        _createElementVNode("td", _hoisted_6, _toDisplayString(_unref(formatDate)(item?.pickupExpectedAt, _unref(dateFormatType).SHORT_TIME)), 1 /* TEXT */),
                        _createCommentVNode(" 배달거리 "),
                        _createElementVNode("td", _hoisted_7, _toDisplayString(item?.deliveryDistance), 1 /* TEXT */),
                        _createCommentVNode(" 출발지 "),
                        _createElementVNode("td", _hoisted_8, _toDisplayString(item?.getPickupShortAddress()), 1 /* TEXT */),
                        _createCommentVNode(" 도착지 "),
                        _createElementVNode("td", _hoisted_9, _toDisplayString(item?.getDropFullAddress()), 1 /* TEXT */)
                    ])), [
                        [_directive_tr_highlight, !!_unref(selectedOrder)]
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["items", "headers"]));
        };
    }
});
